/**
 * This is simple hook that encloses value calculation in a separate function and returns it
 *
 * @param factory
 */
export function useValue<T>(factory: () => T) {
    return factory();
}